<template>
  <v-dialog v-model="visible" :max-width="maxWidth" persistent>
    <v-card>
      <v-toolbar dark flat dense :color="defaultFormColor">
        <v-toolbar-title><v-icon class="pr-2">help</v-icon>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-html="text" class="pt-4 pb-2"></v-card-text>
      <v-card-actions>

        <v-spacer />

        <v-btn text @click="cancel">{{ defaultNoText }}</v-btn>
        <v-btn text color="primary" @click="confirm">{{ defaultYesText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppConfirm from '@/plugins/confirm.js'

export default {
  name: 'AppConfirm',
  data() {
    return {
      visible: false,
      title: null,
      text: null,
      formColor: null,
      width: 400,
      yesText: null,
      noText: null,
      onConfirm: {},
      onCancel: {}
    }
  },
  computed: {
    defaultYesText () {
      return this.yesText !== null
        ? this.yesText
        : this.getExpression('Button', 'Yes')
    },
    defaultNoText () {
      return this.noText !== null
        ? this.noText
        : this.getExpression('Button', 'No')
    },
    defaultFormColor () {
      return this.formColor !== null
        ? this.formColor
        : 'red darken-2'
    },
    maxWidth () {
      return `${this.width}px`
    }
  },
  methods: {   
    show (params) {
      this.resetColor()
      this.visible = true
      this.title = params.title
      this.text = params.text
      if (!this.isNullOrUndefined(params.yesText)) this.yesText = params.yesText
      if (!this.isNullOrUndefined(params.noText)) this.noText = params.noText
      if (!this.isNullOrUndefined(params.formColor)) this.formColor = params.formColor
      if (!this.isNullOrUndefined(params.width)) this.width = params.width
      if (!this.isNullOrUndefined(params.onConfirm)) this.onConfirm = params.onConfirm
      if (!this.isNullOrUndefined(params.onCancel)) this.onCancel = params.onCancel
    },
    confirm () {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm()
        this.visible = false
      } else {
        this.visible = false
      }
    },
    cancel () {
      if (typeof this.onCancel === 'function') {
        this.onCancel()
        this.visible = false
      } else {
        this.visible = false
      }
    },
    resetColor () {
      this.formColor = 'red darken-2'
    }
  },
  beforeMount() {
    AppConfirm.EventBus.$on('show', (params) => {
      this.show(params)
    })
  }
}
</script>
